import { Link } from '@remix-run/react';
import Contact from '~/assets/icons/ContactCard';

export function ContactCard() {
  return (
    <div className="w-full rounded-2xl border border-gray-200 bg-gradient-to-b from-primary/5 to-white p-8 text-center shadow-sm">
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
        <Contact className="h-9 w-auto" />
      </div>
      <h3 className="mb-3 text-xl font-bold text-gray-900">
        Still Have Questions?
      </h3>
      <p className="mb-6 text-sm leading-relaxed text-gray-600">
        Our knowledgeable support team is here to help you choose the right
        products and answer any questions about your order.
      </p>
      <Link
        to="/contact"
        className="inline-block w-full rounded-lg bg-primary px-6 py-3 text-base font-medium text-white shadow-sm transition hover:opacity-90 hover:shadow-md"
      >
        Contact Support
      </Link>
    </div>
  );
}
